import getDayjsInstance from './getDayjsInstance';

const blockBeforeCurrentDateAfterYear = () =>
  getDayjsInstance().add(1, 'year').format('YYYY-MM-DD');

export default blockBeforeCurrentDateAfterYear;
